











































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class OtpInput extends Vue {
  @Prop({ default: "" }) readonly label!: string;
  @Prop({ default: "" }) readonly value!: string;
  @Prop({ default: "text" }) readonly type!: string;
  @Prop({ default: false }) readonly inputError!: boolean;
  @Prop({ default: false }) readonly required!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: true }) readonly showAlertMessage!: boolean;
  @Prop({ default: "" }) readonly errorMessage!: string;
  @Prop({ default: "" }) readonly tooltip!: string | Array<any>;
  @Prop({ default: "right" }) readonly tooltipPosition!: string;

  private OTP_LENGTH = 6;
  private digits: string[] = Array(this.OTP_LENGTH).fill("");
  private currentFocus = 0;

  @Watch("value", { immediate: true })
  valueChanged(newVal: string) {
    if (newVal && newVal.length === this.OTP_LENGTH) {
      this.digits = newVal.split("").slice(0, this.OTP_LENGTH);
    } else if (!newVal) {
      this.digits = Array(this.OTP_LENGTH).fill("");
    } else if (newVal && newVal.length < this.OTP_LENGTH) {
      const array = newVal.split("").slice(0, this.OTP_LENGTH);
      while (array.length < this.OTP_LENGTH) array.push("");
      this.digits = array;
    }
  }

  mounted() {
    this.$nextTick(() => {
      this.focusInput(0);
    });
  }

  public focusInput(index: number) {
    const inputs = this.$refs.otpInput as HTMLInputElement[];
    if (inputs && inputs[index]) {
      inputs[index].focus();
    }
  }

  public onInput(event: Event, index: number) {
    const target = event.target as HTMLInputElement;
    const value = target.value.replace(/\D/g, "");

    if (!value) {
      this.digits[index] = "";
      this.emitValue();
      return;
    }

    if (value.length === 1) {
      this.digits[index] = value[0];
      this.emitValue();
      if (index < this.OTP_LENGTH - 1) {
        this.focusInput(index + 1);
      }
      return;
    }

    // Handle paste or multiple character input
    for (let i = 0; i < this.OTP_LENGTH; i++) {
      this.digits[i] = value[i] || "";
    }
    this.emitValue();
    this.$nextTick(() => {
      this.focusInput(Math.min(value.length, this.OTP_LENGTH - 1));
    });
  }

  public onKeydown(event: KeyboardEvent, index: number) {
    if ((event.ctrlKey || event.metaKey) && event.code === "KeyV") {
      return;
    }

    if (event.key === "Backspace") {
      if (this.digits[index]) {
        this.digits[index] = "";
        this.emitValue();
      } else if (index > 0) {
        this.focusInput(index - 1);
      }
      event.preventDefault();
    } else if (event.key === "ArrowLeft" && index > 0) {
      this.focusInput(index - 1);
      event.preventDefault();
    } else if (event.key === "ArrowRight" && index < this.OTP_LENGTH - 1) {
      this.focusInput(index + 1);
      event.preventDefault();
    } else if (!/\d/.test(event.key) && event.key.length === 1) {
      event.preventDefault();
    }
  }

  public onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const paste = clipboardData.getData("text").replace(/\D/g, "");
    for (let i = 0; i < this.OTP_LENGTH; i++) {
      this.digits[i] = paste[i] || "";
    }
    this.emitValue();
    this.$nextTick(() => {
      this.focusInput(Math.min(paste.length, this.OTP_LENGTH - 1));
    });
    event.preventDefault();
  }

  public emitValue() {
    this.$emit("input", this.digits.join(""));
    this.$emit("change", this.digits.join(""));
  }

  public onFocus(index: number) {
    this.currentFocus = index;
    this.$emit("focus");
    this.$nextTick(() => {
      const inputs = this.$refs.otpInput as HTMLInputElement[];
      if (inputs && inputs[index]) {
        inputs[index].select();
      }
    });
  }
}
